module.exports = __webpack_public_path__ + "eca877c192e583a9a1e78c53a90f7a4f.MP3";